<template>
	<div>
		<el-form :inline="true">
			<el-form-item>
				<el-input
						v-model="searchForm.orderNo"
						placeholder="订单号"
						clearable
						style="width: 200px"
				>
				</el-input>
				&nbsp;&nbsp;
				<el-select v-model="searchForm.payStatus" placeholder="支付状态" style="width: 200px" clearable>
					<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button @click="getOrderList">搜索</el-button>
			</el-form-item>
		</el-form>

		<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				border
				stripe>
			<el-table-column
					prop="orderNo"
					label="订单号"
					width="180">
			</el-table-column>
			<el-table-column
					prop="organizeName"
					label="组织名称">
			</el-table-column>
			<el-table-column
					prop="subscribePlan"
					label="订阅计划"
					width="120">
			</el-table-column>
			<el-table-column
					prop="amount"
					label="金额"
					width="80">
			</el-table-column>
			<el-table-column
					prop="payStatus"
					label="支付状态"
					width="100">
			</el-table-column>
			<el-table-column
					prop="createTime"
					width="180"
					label="创建时间"
			>
			</el-table-column>
			<el-table-column
					prop="createBy"
					width="160"
					label="创建人"
			>
			</el-table-column>

		</el-table>

		<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="page.current"
				:page-size="page.size"
				:total="page.total">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		name: "Order",
		data() {
			return {
				searchForm: {},
				page: {
					total: 0,
					size: 10,
					current: 1,
				},
				tableData: [],
				options: [ {
					value: '未支付',
					label: '未支付'
				}, {
					value: '已支付',
					label: '已支付'
				}]
			}
		},
		created() {
			this.getOrderList(this.page)
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.page.size = val
				this.getOrderList(this.page)
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page.current = val
				this.getOrderList(this.page)
			},
			getOrderList(page) {
				this.$axios.post("/uxm/order/page", {
					orderNo: this.searchForm.orderNo,
					payStatus: this.searchForm.payStatus,
					current: page == null ? this.page.current : page.current,
					size: page == null ? this.page.size : page.size,
				}).then(res => {
					this.tableData = res.data.data.records
					this.page.size = res.data.data.size
					this.page.current = res.data.data.current
					this.page.total = res.data.data.total
				})
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}

</style>
